<template lang="pug">
vs-row(v-if="form.data.traductions")
  vs-col(:w="12")
    v-tabs(paddingX)
      v-tab(v-for="traduction in Object.keys(form.data.traductions)" :name="getTitleTab(traduction)" :selected="traduction === 'es'")
        vs-row(direction="column")
          vs-col(:w="12")
            b-form-group
              vs-input(v-model="form.data.traductions[traduction].main_title" label-placeholder='Título principal' shadow :disabled="isLoading")
          vs-col(:w="12")
            b-form-group
              vs-input(v-model="form.data.traductions[traduction].text" label-placeholder='Título secundario' shadow :disabled="isLoading")
    vs-row(justify="flex-end")
      vs-button(primary size="large" @click="updateRecord" :loading="isLoading") Aceptar
  vs-col(:w="6")
    b-form-group
      uploader(v-model="fileList.defaultHeader" :autoUpload="false" :limit="1" :maxWidth="1440" title="Background default header" @on-change="_uploadImage('default')")
      span Tamaño recomendado 1440 x 600 pixeles
  vs-col(:w="6")
    b-form-group
      uploader(v-model="fileList.mobileHeader" :autoUpload="false" :limit="1" title="Background para movil" @on-change="_uploadImage('mobile')")
      span Tamaño recomendado 1242 x 2208 pixeles o equivalente
</template>

<script>
import { VTabs, VTab } from '@/components/tabs'
import BFormGroup from '@/components/forms/BFormGroup'
import Uploader from 'vux-uploader-component'
import LoaderMixin from '../../mixins/LoaderMixin'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('Pages')

export default {
  name: 'HeaderInformation',
  components: {
    Uploader,
    VTabs,
    VTab,
    BFormGroup
  },
  mixins: [LoaderMixin],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    fileList: {
      defaultHeader: [],
      mobileHeader: []
    },
    percent: 0
  }),
  computed: {
    hasFiles () {
      return this.fileList.defaultHeader[0].blob || this.fileList.mobileHeader[0].blob
    }
  },
  watch: {
    form: {
      handler () {
        this.fileList.defaultHeader = []
        this.fileList.mobileHeader = []
        if (this.form.background) {
          this.fileList.defaultHeader.push({ url: this.form.background, type: 'default' })
        }
        if (this.form.background_mobil) {
          this.fileList.mobileHeader.push({ url: this.form.background_mobil, type: 'mobile' })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['deleteImage', 'setAlertMessage', 'uploadImage', 'editRecord']),
    async _uploadImage (type) {
      if (this.hasFiles) {
        this.onLoading()
        const file = this.getFileToUpload(type)
        await this.uploadImage({
          ...this.form,
          file,
          type
        })
        this.onLoadingClose()
      }
    },
    async updateRecord () {
      this.toggleLoading()
      await this.editRecord({
        ...this.form,
        data: JSON.stringify(this.form.data)
      })
      this.toggleLoading()
    },
    getTitleTab (key) {
      return key === 'es' ? 'Español' : 'Íngles'
    },
    getFileToUpload (type) {
      if (type === 'default' && this.fileList.defaultHeader[0].blob) {
        return this.fileList.defaultHeader[0].blob
      }
      return this.fileList.mobileHeader[0].blob
    }
  }
}
</script>
